import React, { useCallback } from 'react';
import {
  BrandCreatorProfile,
  BrandProfileReview,
  getCreatorBrandReviews,
  replyToCreatorRating,
} from '../../../api/payment/brand-profile.api';
import { BRAND_PROFILE_COPY } from '../../../utils/brand-profile';
import { BrandProfileMetricsView } from './brand-profile-metrics';
import BrandReviewList from './brand-review-list';

// Hằng riêng: prop tên `role` bị jsx-a11y/aria-role hiểu nhầm là ARIA role khi truyền chuỗi trực tiếp.
const METRICS_ROLE = 'creator' as const;

/** Tab "Hợp tác" trên trang cá nhân creator (spec 2026-10-12 §4). Chủ hồ sơ thấy ô trả lời ở đánh giá chưa trả lời. */
const CreatorCollabTab: React.FC<{ creatorId: string; profile: BrandCreatorProfile; isOwner: boolean }> = ({
  creatorId,
  profile,
  isOwner,
}) => {
  const load = useCallback((page: number) => getCreatorBrandReviews(creatorId, page), [creatorId]);
  const canReply = useCallback((r: BrandProfileReview) => isOwner && !r.reply, [isOwner]);

  return (
    <div className="flex flex-col gap-3">
      <BrandProfileMetricsView metrics={profile.metrics} joinedAt={profile.joinedAt} ratingCount={profile.ratingCount} role={METRICS_ROLE} />
      <BrandReviewList
        load={load}
        canReply={canReply}
        sendReply={replyToCreatorRating}
        replyAuthorLabel={BRAND_PROFILE_COPY.creatorReplyLabel}
      />
    </div>
  );
};

export default CreatorCollabTab;
